<h2 mat-dialog-title>{{selectedDataDefList.Name}}</h2>
<mat-dialog-content>
  <!-- Static -->
  <ng-container *ngIf="(selectedDataDefList && !selectedDataDefList.IsDynamic)">
    <data-definition-static [DataDefList]="selectedDataDefList" [addClick]="addClick" [saveSequenceClick]="saveSequenceClick"></data-definition-static>
  </ng-container>
  <!-- Dynamic -->
  <ng-container *ngIf="(selectedDataDefList && selectedDataDefList.IsDynamic)">
    <data-definition-dynamic [DataDefList]="selectedDataDefList" [addClick]="addClick" [saveSequenceClick]="saveSequenceClick"></data-definition-dynamic>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>
    <tyl-button *ngIf="(selectedDataDefList && selectedDataDefList.UserCanEdit && (selectedDataDefList.IsDynamic || (!selectedDataDefList.IsDynamic && !selectedDataDefList.ReadOnly)))" image="add.png" disabledImage="Add disabled.png" label="Add Code" (clickEvent)="addClick.emit()"></tyl-button>
  </div>
  <div class='flex-footer-right'>
    <tyl-button *ngIf="selectedDataDefList.IsSortable" image="save.png" label="Save" (clickEvent)="saveSequenceClick.emit()"></tyl-button>
    <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>